import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { setShowTokenPopup, setUsersPins } from '../actions/localStates'

class TokenPinPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          pin: ""
      }

      this.handlePinInput = this.handlePinInput.bind(this);

      this.setPin = this.setPin.bind(this);
      this.closeTokenPinPopup = this.closeTokenPinPopup.bind(this);

      this.handlePinKeyUp = this.handlePinKeyUp.bind(this, 'pinInput');
  }

  componentDidMount() {
      var element = document.getElementById("pin");
      element.focus();
      document.addEventListener('keyup', this.handlePinKeyUp);
  }

  componentWillUnmount() {
      document.removeEventListener('keyup', this.handlePinKeyUp);
  }

  handlePinKeyUp(refName, e) {
      if (e.keyCode === 13 && refName === "pinInput") {
          document.getElementById("submitPin").click();
          document.activeElement.blur();
      }
  }

  handlePinInput (e) {
    // console.log(e.target.value)
    this.setState({pin: e.target.value})
  }

  setPin () {
    var pins = this.props.userReducer.usersPins;

    pins[this.props.userReducer.tempId] = this.state.pin;

    this.props.actions.setUsersPins(pins);
    this.props.closeTokenPopup(this.props.userReducer.tempId);
  }

  closeTokenPinPopup () {
    this.props.actions.setShowTokenPopup(false);
  }

  hoverPin() {
        this.setState({showPin: true})
  }

  outPin() {
      this.setState({showPin: false})
  }

  render() {
    let isEnabled = this.state.pin.length >= 8
    ? true
    : false

      return (
          <div className='popup'>
              <div className={"popup_inner_user_token_pin"}>
                  <div className="col-12" style={{marginTop: "30px"}}>
                      <div>
                          <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingTop: "0px", paddingBottom: "0px"}}>{i18next.t("pinInput")}</label>
                          <div className="col-12 input-group">
                              <input id="pin" className="form-control" value={this.state.pin} type={this.state.showPin ? "input" : "password"} onChange={this.handlePinInput} />
                              <div className="input-group-append">
                                  <div className="input-group-text" onMouseOver={this.hoverPin.bind(this)} onMouseOut={this.outPin.bind(this)}><i className="fa fa-eye"></i></div>
                              </div>
                          </div>

                      </div>
                      <div style={{float: "right", marginRight: "15px", paddingTop: "10px"}}>
                          <button className="btn btn-info" id="submitPin" style={{marginLeft: "5px", marginBottom: "30px"}} disabled={!isEnabled} onClick={this.setPin}>{i18next.t("setPin")}</button>
                          <button className="btn btn-outline-info" style={{marginLeft: "5px", marginBottom: "30px"}} onClick={this.closeTokenPinPopup}>{i18next.t("cancelLabel")}</button>
                      </div>
                  </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        selectedClient: state.clientReducer,
        login: state.loginReducer,
        userReducer: state.userReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setShowTokenPopup, setUsersPins
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenPinPopup);